var custom = {};
var win = $(window);
var doc = $(document);


custom = {
  defaults: {
  },
  onInit: function() {
    var vm = this;

    vm.reviewSlider()
    vm.specsBlockSlider()
    vm.mediaQuoteToggle()
    vm.collectionLookup()
    vm.accordionToggle()
    vm.btnNavScrolling()
    vm.playYoutubeVideo()
  },
  onLoad: function(e) { },
  onResize: function(e) {
    var vm = this;
  },
  onScroll: function() {
    var vm = this;

    if ($('.button-navs-section').length > 0) {
      vm.stickyButtonNav()
    }
  },

  reviewSlider: function() {
    var reviews = $('.reviews-section-layout .reviews')

    if( reviews.length ) {
      reviews.slick({
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1
      })
    }
  },

  specsBlockSlider: function() {
    var container = $('.specs-block-layout .specs-block-items')
    container.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      fade: true,
      infinite: true,
      accessibility: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            dots: true
          }
        }
      ]
    })
  },

  mediaQuoteToggle: function() {
    var icons = $('.media-quote-block .icons')
    var quotes = $('.media-quote-block .quote-wrapper')

    quotes.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      asNavFor: '.media-quote-block .icons',
      draggable: false
    });
    icons.slick({
      slidesToShow: 5,
      slidesToScroll: 5,
      asNavFor: '.media-quote-block .quote-wrapper',
      dots: false,
      arrows: false,
      focusOnSelect: true,
      infinite: true
    });
  },

  collectionLookup: function() {
    var reviews = $('.collections-lookup-block .product-grid')
    if( reviews.length ) {
      reviews.slick({
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        accessibility: false,
        responsive: [
          {
            breakpoint: 9999,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5
            }
          },
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              arrows: false
            }
          }
        ]
      })
    }
  },

  accordionToggle: function() {
    var accordionItem = $('.accordion-blocks-layout .accordion-header');
    
    accordionItem.click(function() {
      var _this = $(this);
      
      accordionItem.not(this).parent().removeClass('active-item')
      accordionItem.not(this).next().slideUp()
      _this.parent().toggleClass('active-item')
      _this.next().slideToggle();
    })
  },

  btnNavScrolling: function() {
    var btn = $('.button-navs a')
    var offset = ( win.innerWidth() > 1200 ) ? 136 : 80;
    btn.click(function(e) {
      e.preventDefault();
      var route = $(this).attr('href')
      $('html,body').animate({scrollTop:$(route).offset().top - offset}, 800);
      console.log('offset', offset)
    })
  },


  stickyButtonNav: function() {
    var st = win.scrollTop(),
        startPoint = $('.button-navs-section').outerHeight() + $('.button-navs-section').offset().top - 150,
        endPoint = $('.collection-grid').offset().top,
        nav = $('.button-navs .button-items');

    if(win.innerWidth() > 768 ) {

      if( st >= startPoint && st < endPoint ) {
        nav.addClass('sticky')
      } else if( st < startPoint || st >= endPoint ) {
        nav.removeClass('sticky')
      }

    }
  },

  playYoutubeVideo: function() {
    var video = $('.youtube-video');

    video.on('click', function(e) {
      $(this).find('iframe')[0].src += "?autoplay=1";
      $(this).addClass('played')

      e.preventDefault()
    })
    
  },

};

doc.ready(function() {
  custom.onInit();
});

win.on('load', function() {
  custom.onLoad();
});

win.resize(function() {
  custom.onResize();
});

win.scroll(function() {
  custom.onScroll()
})